var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { title: "Atenção", visible: _vm.isVisible, width: 600 },
      on: {
        "update:visible": function($event) {
          _vm.isVisible = $event
        },
        closeModal: function($event) {
          return _vm.beforeClose()
        }
      }
    },
    [
      _c(
        "template",
        { staticClass: "body", slot: "body" },
        [
          _c(
            "validation-observer",
            { ref: "validation", attrs: { tag: "form" } },
            [
              _c(
                "el-row",
                { staticClass: "info" },
                [
                  _c("el-col", { attrs: { span: 2 } }, [
                    _c("i", { staticClass: "fa fa-exclamation-circle fa-2x" })
                  ]),
                  _c(
                    "el-col",
                    {
                      staticClass: "alerts",
                      staticStyle: { "margin-left": "2%", "margin-top": "-2%" },
                      attrs: { span: 21 }
                    },
                    [
                      _vm.sIndireta
                        ? _c("span", [
                            _vm._v(
                              "Após a ação, o processo será encaminhado para caixa de suspensão e será submetido a avaliação do Coordenador."
                            )
                          ])
                        : _vm._e(),
                      _c("br"),
                      _vm.sIndireta
                        ? _c("span", [_vm._v("Deseja continuar?")])
                        : _vm._e(),
                      _vm.msgAprovacao
                        ? _c("span", [
                            _vm._v("Deseja aprovar a suspensão do processo?")
                          ])
                        : _vm._e(),
                      _vm.msgSuspensao
                        ? _c("span", [_vm._v("Deseja suspender o processo?")])
                        : _vm._e(),
                      _vm.isCancelamento
                        ? _c("span", [
                            _vm._v("Deseja cancelar a suspensão do processo?")
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { justify: "space-between" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 19 } },
                    [_c("Label", { attrs: { label: "Justificativa:" } })],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "text-right", attrs: { span: 5 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-modelo",
                          attrs: { type: "primary" },
                          on: { click: _vm.openModalJustificativa }
                        },
                        [
                          _vm._v("Modelo  "),
                          _c("div", { staticClass: "fa fa-file icon-file" })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-editor-texto-modal", {
                          ref: "editorTexto",
                          class: { erro: errors.length },
                          attrs: { value: _vm.dadosSuspensao.justificativa },
                          on: { onTextChange: _vm.onTextChange }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ]),
                        _vm.showModalDespacho
                          ? _c("app-modal-selecionar-modelo-notificacao", {
                              attrs: {
                                tiposModelo: [7],
                                titulo: _vm.tituloModalModelo,
                                idProcesso: _vm.idProcesso,
                                showModal: _vm.showModalDespacho
                              },
                              on: {
                                closeModal: _vm.fecharModalJustificativa,
                                setTextoJustificativa: _vm.setTextoJustificativa
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "span",
          {
            class: _vm.isBotaoUnicoSetClass ? "button-aprove" : "buttons",
            attrs: { slot: "footer" },
            slot: "footer"
          },
          [
            _vm.isReprovacao
              ? _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "default" },
                    on: {
                      click: function($event) {
                        return _vm.reprovarSuspensao()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _c("i", { staticClass: "fa fa-times" }),
                      _c("b", { staticClass: "msg" }, [
                        _vm._v("Reprovar suspensão")
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            !_vm.isCancelamento
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.aprovarSuspensao()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _c("i", { staticClass: "fa fa-check" }),
                      _c("b", { staticClass: "msg" }, [
                        _vm._v(
                          _vm._s(
                            _vm.sIndireta
                              ? "Solicitar suspensão"
                              : _vm.msgAprovacao
                              ? "Aprovar suspensão"
                              : "Suspender processo"
                          )
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm.isCancelamento
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.cancelarSuspensao()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _c("i", { staticClass: "fa fa-ban" }),
                      _c("b", { staticClass: "msg" }, [
                        _vm._v("Cancelar suspensão")
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d5635bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d5635bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalSuspensaoProcesso.vue
// module id = null
// module chunks = 